import { render, staticRenderFns } from "./ElettrostimolatoreEditComponent.vue?vue&type=template&id=43614eb3&scoped=true"
import script from "./ElettrostimolatoreEditComponent.vue?vue&type=script&lang=js"
export * from "./ElettrostimolatoreEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ElettrostimolatoreEditComponent.vue?vue&type=style&index=0&id=43614eb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43614eb3",
  null
  
)

export default component.exports